import { FC, useEffect, memo, useState, useMemo } from 'react';
import { getDimensions } from '../../core/dimensions';
import { calculatPrice } from '../../core/price';
// import { useConfig } from '../../hooks/config';
// import { fontSizes, tailedLetters } from '../Viewer/config';
import Option from './Option';
import Slider from './Slider';

interface iOptions {
  name: string;
  value: string;
  price: number | null | ((size: string, value: any, options: any) => number);
  description?: string;
  dimensions?: number[];
  exact?: boolean;
}

interface iGridSelectorProps {
  content: any;
  config: any;
  options: iOptions[];
  value: string;
  lineHeight: number;
  onChange: (value: string) => void;
}

const FontFamilies: FC<iGridSelectorProps> = memo(({ options, value, onChange, content, config, lineHeight }) => {
  // const _config = useConfig();
  const [prevSize, setPrevSize] = useState(0);
  const [isSliderVisible, setIsSliderVisible] = useState(false);

  useEffect(() => {
    if (value === 'Custom') setIsSliderVisible(true);
    else {
      setIsSliderVisible(false);
      setPrevSize(options.find((option) => option.value === value)?.dimensions?.[0] ?? 6);
    }
  }, [value]);

  const activeOption = options.find((_) => _.value === value);
  let currentPrice = 0;
  if (typeof activeOption?.price === 'number') currentPrice = activeOption.price;
  else if (typeof activeOption?.price === 'function') currentPrice = activeOption.price(config.size, content, config);
  else if (value.toUpperCase().includes('CUSTOM')) currentPrice = calculatPrice(value, content, config);

  const _handleSliderChange = (width: number, height: number, price: number) => {
    onChange(`CUSTOM_${width}x${height}x${price}`);
  };

  const [numberOfLines, lineWidth, letterNumber] = useMemo(() => {
    const numberOfLines = content.filter((line: any) => line.children[0]?.text?.length > 0).length;

    const lineWidths = content.map((line: any) => {
      const lineContent = line.children
        .map((leaf: any) => leaf.text)
        .join('')
        .replace(/ /g, '')
        .trim();

      return lineContent.length;
    });

    return [numberOfLines, Math.max(...lineWidths), lineWidths.reduce((sum: number, w: number) => sum + w, 0)];
  }, [JSON.stringify(content), config.lineHeight]);

  return (
    <div className='grid-selector'>
      {options.map((option) => {
        let _price = 0;
        if (typeof option.price === 'number') _price = option.price;
        else if (typeof option.price === 'function') {
          _price = option.price(option.value === 'Custom' ? value : option.value, content, config);
        }

        const letterWidth = Number(option.dimensions?.[0] || value?.split('_')?.[1]?.split('x')?.[0]);

        const dims = getDimensions(letterWidth, lineHeight, content);

        return (
          <Option
            {...option}
            description={
              option.description === undefined && dims.width ? `${Math.round(dims.width)}cm` : option.description
            }
            price={_price ? Math.round(_price - currentPrice) : null}
            key={option.value}
            onSelect={onChange}
            dimensions={option.dimensions ? [dims.width, dims.height] : undefined}
            active={value.split('_')[0].toUpperCase() === option.value.toUpperCase()}
          />
        );
      })}
      {isSliderVisible && (
        <Slider
          {...{ lineHeight, numberOfLines, lineWidth, letterNumber, defaultValue: prevSize, content, config }}
          onSubmit={_handleSliderChange}
        />
      )}
    </div>
  );
});

export default FontFamilies;
